import React from "react";

const AccessDeniedPlaceholder = () => {
  return (
    <div className='accessDeniedPlaceholder'>
      <div className='accessDeniedPlaceholder__line accessDeniedPlaceholder__line_large' />
      <div className='accessDeniedPlaceholder__line accessDeniedPlaceholder__line_medium' />
      <div className='accessDeniedPlaceholder__cards'>
        <div className='accessDeniedPlaceholder__card' />
        <div className='accessDeniedPlaceholder__card' />
        <div className='accessDeniedPlaceholder__card' />
      </div>
      <div className='accessDeniedPlaceholder__table' />
    </div>
  );
};

export default AccessDeniedPlaceholder;
